/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBitNot } from '../../factoriesAny.js';
export var bitNotDependencies = {
  typedDependencies,
  createBitNot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBitNot.generated.js
// module id = 1317
// module chunks = 2